import { GetServerSideProps } from "next";
import { ReactElement } from "react";
import BestFloorCleaningMachinesWrapper from "@components/layouts/bestFloorCleaningMachinesWrapper";

import { getPageProps } from "@services/initial-calls";
import PrivacyPolicy from "@components/shared/legal/privacyPolicy";

export default function BestPostageMetersHome(): ReactElement {
    return (
        <BestFloorCleaningMachinesWrapper>
            <PrivacyPolicy
                category="Floor Cleaning Machines"
                domain="BestFloorCleaningMachines.com"
            />
        </BestFloorCleaningMachinesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "home", { pageTitle: "Privacy Policy" });
};
